// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"fd9a36b4107bb931c03d","655":"44c46f1330ddad38c484"}[chunkId] + ".js";
};